/**
 * Gestion du bouton 'copy link'
 */

$(document).ready(function () {

  let copyBtns = document.querySelectorAll('[data-copy]');

  copyBtns.forEach((copyBtn) => {

    /**
     * Evènement au clic sur bouton 'Copier le lien'
     */
    copyBtn.addEventListener('click', function(e){
      e.preventDefault();
      copyUrlToClipboard();
    });

  });

  /**
   * Copie l'url courante dans le presse-papier
   */
  function copyUrlToClipboard() {
    // crée l'input factice provisoire
    let dummy = document.createElement('input');
    // récupère l'url courante
    let url = window.location.href;

    // intègre l'input dans le DOM
    document.body.appendChild(dummy);
    // assigne la valeur de l'url à l'input
    dummy.value = url;
    // sélectionne la valeur de l'élément
    dummy.select();
    // copie la sélection courante dans le presse papier
    document.execCommand('copy');
    // supprime l'input factice provisoire
    document.body.removeChild(dummy);
  }

});
